import { FileText, Loader2 } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import PrdDocumentModal from '@/components/PrdDocumentModal';
import { cn } from '@/lib/utils';

/**
 * Right-rail PRD artifact (static-report style). Persists through GENERATE and DONE.
 */
export default function PrdArtifactCard({
  sessionId,
  phase,
  prdAvailable,
  prdChecking,
  className,
}) {
  if (!sessionId) {
    return null;
  }

  const phaseUpper = String(phase || '').toUpperCase();
  const docLabel = `requirements-prd-${sessionId.slice(0, 8)}.docx`;

  return (
    <Card className={cn('overflow-hidden border-amber-200/90 shadow-md', className)}>
      <CardHeader className="border-b border-amber-100 bg-gradient-to-r from-amber-50 to-orange-50/80 pb-3 pt-4">
        <CardTitle className="flex items-center gap-2 text-base text-amber-950">
          <FileText className="h-5 w-5" />
          PRD document
        </CardTitle>
        <CardDescription className="text-xs text-amber-900/80">
          Product requirements for this chat session — available after confirmation.
        </CardDescription>
      </CardHeader>
      <CardContent className="p-4">
        {prdAvailable ? (
          <div className="space-y-4">
            <div className="rounded-lg border border-amber-200/80 bg-amber-50/50 p-4">
              <div className="mb-2 text-sm text-muted-foreground">Document</div>
              <div className="flex items-start gap-2 break-all text-amber-950">
                <FileText className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" />
                <span className="text-sm font-medium">{docLabel}</span>
              </div>
            </div>
            <PrdDocumentModal key={sessionId} sessionId={sessionId} triggerVariant="button" />
          </div>
        ) : (
          <div className="rounded-lg border border-dashed border-amber-200/80 bg-amber-50/30 py-8 text-center">
            {prdChecking || phaseUpper === 'CONFIRM' ? (
              <>
                <Loader2 className="mx-auto mb-3 h-10 w-10 animate-spin text-amber-600" />
                <p className="text-sm font-medium text-amber-950">Preparing PRD…</p>
                <p className="mt-1 px-4 text-xs text-amber-900/70">
                  The document is generated when you reach confirmation. It will appear here when ready.
                </p>
              </>
            ) : (
              <>
                <FileText className="mx-auto mb-3 h-10 w-10 text-amber-300" />
                <p className="text-sm text-muted-foreground">No PRD for this session yet</p>
              </>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
